module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.dacd16c9.eot";